import React from 'react';
import PropTypes from 'prop-types';

import ContactRow from 'modules/Stop/Card/rows/ContactRow';
import AddressRow from 'modules/Stop/Card/rows/AddressRow';

const StopInfoWindow = ({ className, stop }) => (
  <div className={className}>
    <AddressRow stop={stop} className="address-row" />
    <ContactRow stop={stop} className="contact-row" />
  </div>
);

StopInfoWindow.propTypes = {
  className: PropTypes.string,
  stop: PropTypes.shape({}),
};

export default StopInfoWindow;
